import { Component, Input } from '@angular/core';

import { CensoService } from '@app/shared/services/censo.service';

import { Censo } from '@app/shared/models';

type InformacoesUsuario = {
  nome: string;
  cpf: string;
  dataNascimento: string;
  nomeMae?: string
}

@Component({
  selector: 'app-informacoes-andamento',
  templateUrl: './informacoes-andamento.component.html',
  styleUrls: ['./informacoes-andamento.component.scss']
})
export class InformacoesAndamentoComponent {

  @Input() dadosUsuario: any = null as InformacoesUsuario;

  censo: Censo;

  constructor(private censoService: CensoService) {
    this.censo = this.censoService.retornarSessionStorage('censo');
   }
}
